import { Trans } from 'react-i18next';

import i18n from '@/i18n';
import { NotificationIcon } from '../NotificationIcon';
import { NotificationItemHeader } from '../NotificationItemHeader';
import { NotificationItemProps } from '../types';
import StyledRouterLink from '@/components/StyledRouterLink';

const MdmNotificationItem = ({ notification }: NotificationItemProps) => {
  return (
    <NotificationItemHeader
      notification={notification}
      title={
        <>
          <Trans
            i18nKey="notificationItems.mdm.title"
            ns="common"
            components={{ bold: <b /> }}
          />
          <br />
          <Trans
            i18nKey="notificationItems.mdm.description"
            ns="common"
            components={{
              link: (
                <StyledRouterLink
                  id="employees-no-mdm-link"
                  to="/device-management?hasElectricApp=false&hasMDM=false"
                />
              ),
            }}
          />
          <br />
          <br />
        </>
      }
      icon={
        <NotificationIcon
          isNotificationUnseen={!notification.seenAt}
          icon="cog"
        />
      }
      label={i18n.t('common:notificationItems.labels.deviceManagement')}
    />
  );
};

export default MdmNotificationItem;
